import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const leaderboardEntrySchema = z.object({
  rank: z.number(),
  userId: z.string(),
  nickname: z.string().nullable(),
  score: z.number(),
  totalPassed: z.number(),
  totalFailed: z.number(),
  totalReviews: z.number(),
  currentStreak: z.number(),
  maxStreak: z.number(),
  lastActiveDate: z.string().nullable(),
  totalActiveDays: z.number(),
});

const adminLeaderboardDataSchema = z.object({
  entries: z.array(leaderboardEntrySchema),
  total: z.number(),
});

export type IAdminLeaderboardEntry = z.infer<typeof leaderboardEntrySchema>;
export type IGetAdminLeaderboardData = z.infer<typeof adminLeaderboardDataSchema>;

export const getAdminLeaderboardResponseSchema = createApiResponseSchema(
  adminLeaderboardDataSchema,
) as z.ZodSchema<IAPI<IGetAdminLeaderboardData>>;

export type IGetAdminLeaderboardResponse = IAPI<IGetAdminLeaderboardData>;
